import { Routes, Route } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import Dashboard from "../DashboardComponent";
import MainComponent from "../MainComponent";
import HotDispositionSummaryComponent from "../Hot Disposition Summary/hotDispositionSummaryComponent";
import WarmDispositionSummaryComponent from "../Warm Disposition Summary/warmDispositionSummaryComponent";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import BdmToDoComponent from "../ToDoList/TodoList";
import ProfileComponent from "../ProfilePage/ProfileComponent";
import { LoginContext } from "../LoginPage/LoginContext";
import LeadDetailsPage from "../Leads Page/LeadDetailsPage";
import BDMDetailsPage from "../BDM Assigned Page/bdmDetailsPage";
import AllLeadsPage from "../SupervisorDashboard/AllLeadspage";
import MasterDataComponent from "../SupervisorDashboard/MasterDataComponent";
import AuditDetailsPageComponent from "../Audit/AuditDetailsPage";
import CallerPage from "../Dialer/CallerPage";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled, useTheme } from "@mui/material/styles";
import MobileMainComponent from "../MobileMainComponent";
import { useNavigate } from "react-router-dom";
import MobileBDMDetailsPage from "../MobileView/MobileBDMDetailsPage";
import EstimationComponent from "../HOExecutive/EstimationComponent";
import EstimationDetailsPageComponent from "../HOExecutive/EstimationDetailsPage";
import AuditTabComponent from "../Audit/AuditTabComponent";
import AuditMasterDataComponent from "../AuditSupervisor/AuditMasterData";
import ConvertedActionComponent from "../BDM Assigned Page/ConvertedActionComponent";

import MobileConvertedComponent from "../MobileView/MobileConveretedComponent";
import DemoComponent from "../BDM Assigned Page/demoComponent";
import ConvertedViewPage from "../BDM Assigned Page/ConvertedViewPage";
import BdmTabComponent from "../BDM Assigned Page/BdmTabComponent";

import ActionWiseLeadComponent from "../ActionWiseLeads/ActionWiseLeadComponen";
import TraderListComponent from "../Audit/TraderListComponent";

import AuditMasterList from "../AuditSupervisor/AuditMasterList";
import MasterListTableComponent from "../SupervisorDashboard/MasterListTable";
import BiDetailsPageComponent from "../BiAgent/BiDetailsPage";
import BroodingDetailsPageComponent from "../BiAgent/BiBoilerDetailsPage.jsx";

import BiDayopDetailsComponent from "../BiAgent/BiDetails";
import BiTabComponent from "../BiAgent/BiTabComponent";
import BiTraderListComponent from "../BiAgent/TraderListComponent";
import BiMasterDataComponent from "../BiSupervisor/BiMasterData";
import BiMasterBroodingComponent from "../BiSupervisor/BiMasterBrooding.jsx";
import BdmReportComponent from "../BDMReport/BdmReportComponent.jsx";
import QRReportComponent from "../QRFormReport/QRReportComponent.jsx";
import BdmDetailsComponent from "../BDMReport/BdmDetailsPage.jsx";
import SettingsComponent from "../Settings/SettingsComponent.jsx";
import EnquiryLeadsPageComponent from "../EnquiryLeadsPage/EnquiryLeadsPageComponent.jsx";
import ZonalManagerComponent from "../ZonalManager/ZonalManagerComponent.jsx";
import CallingReportComponent from "../IncomingCallingReport/CallingReportComponent.jsx";
import AgentCallDetails from "../IncomingCallingReport/AgentCallDetails.jsx";
import OutgoingCallingReportComponent from "../OutgoingCallReport/OutgoingCallReportComponent.jsx";
import AgentOutgoingCallDetails from "../OutgoingCallReport/AgentOutgoingCallDetails.jsx";
import ParivartanIncomingCallReportComponent from "../ParivartanIncomingCallReport/ParivartanIncomingCallReportComponent.jsx";
import ParivartanAgentCallDetails from "../ParivartanIncomingCallReport/ParivartanAgentCallDetails.jsx";
import ParivartanOutgoingCallReportComponent from "../ParivartanOutgoingCallReport/ParivartanOutgoingCallReportComponent.jsx";
import ParivartanAgentOutgoingCallDetails from "../ParivartanOutgoingCallReport/ParivartanAgentOutgoingCallDetails.jsx";
import AgentRemarkDetailsReportComponent from "../AuditAgentDetailReport/AgentRemarkDetailsReportComponents.jsx";
import AgentFollowupReportComponent from "../AuditAgentDetailReport/AgentFollowupReportComponent.jsx";
import AuditLeadComponent from "../Audit/AuditLeadComponent.jsx";
import LeadDetailsPageComponent from "../SupervisorDashboard/LeadsPageDetails.jsx";
import LeadTableListComponent from "../Leads Page/LeadTableList.jsx";
import GeolocationComponent from "../../GeolocationComponent.jsx";
import AgentWorkingHourReportComponent from "../AuditAgentDetailReport/AgentWorkingHourReport.jsx";
import AgentIncomingReport from "../IncomingCallingReport/AgentIncomingReport.jsx";
import AgentOutcomingReport from "../OutgoingCallReport/AgentOutcomingReport.jsx";
import MasterLeadListComponent from "../AuditSupervisor/MasterLeadList.jsx";
import BdmTaskTypeComponent from "../ToDoList/TaskTypeComponent.jsx";
import AttendanceReportComponent from "../AttendanceReport/AttendanceReportComponent.jsx";
import SupervisorAttendanceReportComponent from "../AttendanceReport/SupervisorAttendanceReport.jsx";
import BdmTravelReportComponent from "../AttendanceReport/BdmTravelReport.jsx";
import BdmAttendanceReportComponent from "../AttendanceReport/BdmAttendanceReport.jsx";
import ProtectedRoute from "../ProtectedRoute.jsx";
import LeaveReport from "../AttendanceReport/LeaveReport.jsx";
import SupervisorLeaveReport from "../AttendanceReport/SupervisorLeaveReport.jsx";
import UnauthorizedComponent from "../UnAuthorizedPage/UnauthorizedComponent.jsx";
import Cookies from "js-cookie";
import PWARestrictedPageComponent from "../UnAuthorizedPage/PWARestrictedPage.jsx";
import GroupMeetingComponent from "../GroupMeeting/GroupMeetingComponent.jsx";
import AddGroupMeetingComponent from "../GroupMeeting/AddGroupMeetingComponent.jsx";
import HRComponent from "../HR/HRComponent.jsx";
import AttendanceMonthlyWiseComponent from "../AttendanceReport/AttendanceMonyhlyWise.jsx";
import KPIDetailsByBdmComponent from "../SupervisorDashboard/KPIDetailsByBdmComponent.jsx";
import ListingPageComponent from "../FishFeed/Agent/ListingPageComponent.jsx";
import TravelReportDetailsByBDM from "../AttendanceReport/TravelReportDetailsByBDM.jsx";
import AgentsToDoListComponent from "../AgentToDoList/AgentToDoListComponent.jsx";
import TeamTravelReportComponent from "../ZonalManager/TeamTravelReportComponent.jsx";
import BdmTravelReportComponentZM from "../ZonalManager/BdmTravelReport.jsx";
import IncommingCalls from "../FishFeed/IncommingCalls/IncommingCallsFishFeed";
import OutgoingCalls from "../FishFeed/OutgoingCalls/OutgoingCallsFishFeed";
import BDMActionsReport from "../ZonalManager/BdmTaskReport.jsx";
import FollowupCalls from "../FishFeed/FollowupCalls/FollowupCalls.jsx";

// incoming outgoin followup agent imports
import OutgoinCallAgent from "../Agent Dashboard/OutgoingCallAgent.jsx";
import IncomingCallAgent from "../Agent Dashboard/IncomingCallAgent.jsx";
import FollowupCallsAgent from "../Agent Dashboard/FollowupCallAgent.jsx";

// supervisor dashboard import
import IncomingOutgoingCallDashboard from "../SupervisorDashboard/IncomingOutgoingCallDashboard.jsx";

import Employees from "../Admin/Employees/Employees.jsx";
import Regions from "../Admin/Regions/Regions.jsx";
import Campaigns from "../Admin/Campaign/Campaigns.jsx";
import AdminRoute from "../Routes/AdminRoutes.jsx";

import Report from "../Reports/Report.jsx";
import CategoryComponent from "../Admin/Category/CategoryComponent.jsx";
import SubCategoryComponent from "../Admin/SubCategory/SubCategoryComponent.jsx";
import CustomerInteractionComponent from "../CustomerInteraction/CustomerInteractionComponent.jsx";
import CustomerDashboardComponent from "../CustomerDashboard/CustomerDashboardComponent.jsx";
import RoBoComponent from "../Admin/RoBoMaster/RoBoMasterComponent.jsx";
import RegionManagementComponent from "../Admin/Region Management/RegionManagementComponent.jsx";
import BuisnessComponent from "../Admin/Buisness/BuisnessComponent.jsx";
import RoleComponent from "../Admin/Role/RoleComponent.jsx";
import StateComponent from "../Admin/State/StateComponent.jsx";
import CustomerMasterForm from "../MdmForm/MdmFormComponent.jsx";
import MdmTableComponent from "../MdmForm/MdmTableComponent.jsx";
import PincodeMasterComponent from "../Admin/Pincode/PincodeMasterComponent.jsx";

const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const user = Cookies.get("authToken"); // Fetch user from cookies
  const isAuthenticated = user ? true : false; // If user exists, set isAuthenticated to true

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/"); // Redirect to Unauthorized page if not authenticated
    }
  }, [isAuthenticated, navigate]);

  return isAuthenticated ? children : null;
};

// Helper function to get cookie by name
const getCookie = (name) => {
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.trim().split("=");
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
};

const PrivateRoutes = () => {
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobileOrPhablet = useMediaQuery("(max-width: 1080px)");
  const navigate = useNavigate();

  const { isLoggedIn, logout } = useContext(LoginContext);

  const isRole101or100 = ["101", "100"].includes(
    localStorage.getItem("empRole")
  );

  const handleLogout = () => {};

  return (
    <>
      <AuthGuard>
        <Box sx={{ display: "flex" }}>
          <CssBaseline />

          {isRole101or100 ? (
            <MainComponent onLogout={handleLogout} />
          ) : (
            <>
              {isMobileOrPhablet ? (
                <MobileMainComponent
                  onLogout={handleLogout}
                ></MobileMainComponent>
              ) : (
                <MainComponent onLogout={handleLogout} />
              )}
            </>
          )}
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 1,
              overflowX: "hidden",
              paddingBottom: "64px",
            }}
          >
            {/* <DrawerHeader /> */}
            <Toolbar />
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              {localStorage.getItem("empRole") == 3 ? (
                <Route path="/lead" element={<ZonalManagerComponent />} />
              ) : (
                <Route path="/lead" element={<LeadTableListComponent />} />
              )}
              <Route
                path="/hotDisposition"
                element={<HotDispositionSummaryComponent />}
              />
              <Route
                path="/warmDisposition"
                element={<WarmDispositionSummaryComponent />}
              />
              <Route path="/bdmAssigned" element={<BdmTabComponent />} />
              <Route path="/profile" element={<ProfileComponent />} />
              <Route path="/leadDetails" element={<LeadDetailsPage />} />
              <Route path="/bdmDetails" element={<BDMDetailsPage />} />
              {/* <Route path="/site_visit" element={<SiteVisitPageComponent />} /> */}
              <Route path="/leadFiltered" element={<AllLeadsPage />} />
              <Route
                path="/leadMaster"
                element={<MasterListTableComponent />}
              />
              <Route
                path="/leadMaster/lead_details"
                element={<LeadDetailsPageComponent />}
              />
              <Route path="/leadAction" element={<AllLeadsPage />} />
              <Route path="/auditLead" element={<AuditLeadComponent />} />
              <Route
                path="/auditLeadDetails"
                element={<AuditDetailsPageComponent />}
              />
              <Route path="/mobilebdmpage" element={<MobileBDMDetailsPage />} />
              <Route
                path="/estimateGeneration"
                element={<EstimationComponent />}
              />
              <Route
                path="/estimateDetails"
                element={<EstimationDetailsPageComponent />}
              />
              <Route
                path="/auditMaster"
                element={<MasterLeadListComponent />}
              />
              <Route
                path="/bdmDetails/converted"
                element={<ConvertedActionComponent />}
              />
              <Route
                path="/bdmDetails/converted/view"
                element={<ConvertedViewPage />}
              />
              <Route
                path="/mobilebdmpage/converted"
                element={<MobileConvertedComponent />}
              />
              <Route
                path="/mobilebdmpage/converted/view"
                element={<ConvertedViewPage />}
              />
              <Route
                path="/leadActionWise"
                element={<ActionWiseLeadComponent />}
              />
              <Route
                path="/auditTraderList"
                element={<TraderListComponent />}
              />

              <Route
                path="/bdmtodo"
                element={
                  <ProtectedRoute>
                    <BdmToDoComponent />
                  </ProtectedRoute>
                }
              />
              <Route path="/bdmtask" element={<BdmTaskTypeComponent />} />

              <Route path="/biLead" element={<BiTabComponent />} />
              <Route
                path="/biLeadDetails"
                element={<BiDetailsPageComponent />}
              />
              <Route
                path="/broodingLeadDetails"
                element={<BroodingDetailsPageComponent />}
              />
              <Route
                path="/biLeaddayop"
                element={<BiDayopDetailsComponent />}
              />
              <Route path="/biMaster" element={<BiMasterDataComponent />} />
              <Route
                path="/biMasterBrooding"
                element={<BiMasterBroodingComponent />}
              />
              <Route path="/biTraderList" element={<BiTraderListComponent />} />

              <Route path="/bdmReport" element={<BdmReportComponent />} />
              <Route
                path="/bdmReport/details/:bdm_id"
                element={<BdmDetailsComponent />}
              />
              <Route path="/qrReport" element={<QRReportComponent />} />
              <Route path="/settings" element={<SettingsComponent />} />

              <Route
                path="/enquiry_data"
                element={
                  <EnquiryLeadsPageComponent></EnquiryLeadsPageComponent>
                }
              />
              {isRole101or100 ? (
                <Route
                  path="/calling_report"
                  element={
                    localStorage.getItem("empRole") === "100" ? (
                      <AgentIncomingReport />
                    ) : (
                      <CallingReportComponent />
                    )
                  }
                />
              ) : (
                <Route
                  path="/calling_report"
                  element={<ParivartanIncomingCallReportComponent />}
                />
              )}
              {isRole101or100 ? (
                <Route
                  path="/calling_report/call_details/:agentNo/:agentName"
                  element={<AgentCallDetails />}
                />
              ) : (
                <Route
                  path="/calling_report/call_details/:agentName"
                  element={<ParivartanAgentCallDetails />}
                />
              )}
              {isRole101or100 ? (
                <Route
                  path="/outgoing_calling_report"
                  element={
                    localStorage.getItem("empRole") === "100" ? (
                      <AgentOutcomingReport />
                    ) : (
                      <OutgoingCallingReportComponent />
                    )
                  }
                />
              ) : (
                <Route
                  path="/outgoing_calling_report"
                  element={<ParivartanOutgoingCallReportComponent />}
                />
              )}
              {isRole101or100 ? (
                <Route
                  path="/outgoing_calling_report/call_details/:agentNo/:agentName"
                  element={<AgentOutgoingCallDetails />}
                />
              ) : (
                <Route
                  path="/outgoing_calling_report/call_details/:agentName"
                  element={<ParivartanAgentOutgoingCallDetails />}
                />
              )}
              {isRole101or100 ? (
                <Route
                  path="/remark_details_report"
                  element={<AgentRemarkDetailsReportComponent />}
                />
              ) : (
                <Route
                  path="/remark_details_report"
                  element={<AgentRemarkDetailsReportComponent />}
                />
              )}
              {isRole101or100 ? (
                <Route
                  path="/followup_details_report"
                  element={<AgentFollowupReportComponent />}
                />
              ) : (
                <Route
                  path="/followup_details_report"
                  element={<AgentFollowupReportComponent />}
                />
              )}
              <Route
                path="/work_hour_report"
                element={
                  <AgentWorkingHourReportComponent></AgentWorkingHourReportComponent>
                }
              ></Route>

              <Route
                path="/attendanceReport"
                element={<SupervisorAttendanceReportComponent />}
              ></Route>

              <Route
                path="/attendanceReport/details"
                element={<TravelReportDetailsByBDM />}
              ></Route>

              <Route
                path="/attendanceReport/detailszm"
                element={<BdmTravelReportComponentZM />}
              ></Route>

              {(localStorage.getItem("empRole") === "5" ||
                localStorage.getItem("empRole") === "5") && (
                <Route
                  path="/incoming-outgoing-call"
                  element={<IncomingOutgoingCallDashboard />}
                ></Route>
              )}

              {/* // agent dashboard incoming outgoing followups  */}

              {(localStorage.getItem("empRole") === "1" ||
                localStorage.getItem("empRole") === "1") && (
                <Route
                  path="/incomingCallsAgent"
                  element={<IncomingCallAgent />}
                ></Route>
              )}
              {(localStorage.getItem("empRole") === "1" ||
                localStorage.getItem("empRole") === "1") && (
                <Route
                  path="/outgoingCallsAgent"
                  element={<OutgoinCallAgent />}
                ></Route>
              )}
              {(localStorage.getItem("empRole") === "1" ||
                localStorage.getItem("empRole") === "1") && (
                <Route
                  path="/followupCallsAgent"
                  element={<FollowupCallsAgent />}
                ></Route>
              )}

              {(localStorage.getItem("empRole") === "300" ||
                localStorage.getItem("empRole") === "301") && (
                <Route
                  path="/outgoingCalls"
                  element={<OutgoingCalls />}
                ></Route>
              )}

              {(localStorage.getItem("empRole") === "300" ||
                localStorage.getItem("empRole") === "301") && (
                <Route
                  path="/incommingCalls"
                  element={<IncommingCalls />}
                ></Route>
              )}
              {(localStorage.getItem("empRole") === "300" ||
                localStorage.getItem("empRole") === "301") && (
                <Route
                  path="/followupCalls"
                  element={<FollowupCalls />}
                ></Route>
              )}
              <Route
                path="/attendanceReport/details/map"
                element={<BdmTravelReportComponent />}
              ></Route>

              {localStorage.getItem("empRole") === "2" ||
              localStorage.getItem("empRole") === "3" ? (
                <Route path="/leaveReport" element={<LeaveReport />}></Route>
              ) : (
                <Route
                  path="/leaveReport"
                  element={<SupervisorLeaveReport />}
                ></Route>
              )}

              <Route
                path="/groupMeeting"
                element={<GroupMeetingComponent />}
              ></Route>

              <Route
                path="/groupMeeting/add"
                element={<AddGroupMeetingComponent />}
              ></Route>

              <Route path="/hrReport" element={<HRComponent />}></Route>

              <Route
                path="/monthlyReport"
                element={<AttendanceReportComponent />}
              ></Route>

              <Route
                path="/kpiDetails"
                element={<KPIDetailsByBdmComponent />}
              ></Route>
              <Route
                path="/shrimpLeads"
                element={<ListingPageComponent />}
              ></Route>

              <Route
                path="/bdmDailyTask"
                element={<AgentsToDoListComponent />}
              ></Route>

              <Route
                path="/teamTravelReport"
                element={<TeamTravelReportComponent />}
              ></Route>
              <Route path="/Report" element={<Report />} />

              <Route
                path="/bdmTaskReport"
                element={<BDMActionsReport />}
              ></Route>

              <Route path="/mdm-list" element={<MdmTableComponent />}></Route>

              <Route path="/mdm-form" element={<CustomerMasterForm />}></Route>

              {/* admin routes */}
              <Route
                path="/admin/employees"
                element={
                  <AdminRoute>
                    <Employees />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/regions"
                element={
                  <AdminRoute>
                    <Regions />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/campaigns"
                element={
                  <AdminRoute>
                    <Campaigns />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/category"
                element={
                  <AdminRoute>
                    <CategoryComponent />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/subcategory"
                element={
                  <AdminRoute>
                    <SubCategoryComponent />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/robomaster"
                element={
                  <AdminRoute>
                    <RoBoComponent />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/region-management"
                element={
                  <AdminRoute>
                    <RegionManagementComponent />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/buisness"
                element={
                  <AdminRoute>
                    <BuisnessComponent />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/role-master"
                element={
                  <AdminRoute>
                    <RoleComponent />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/state-master"
                element={
                  <AdminRoute>
                    <StateComponent />
                  </AdminRoute>
                }
              />

<Route
                path="/admin/pincode-master"
                element={
                  <AdminRoute>
                    <PincodeMasterComponent />
                  </AdminRoute>
                }
              />

              <Route
                path="/customer-interaction"
                element={<CustomerInteractionComponent />}
              ></Route>

              <Route path="*" element={<Dashboard />} />
            </Routes>
          </Box>
        </Box>
      </AuthGuard>
    </>
  );
};

export default PrivateRoutes;
